const PIXEL_ID = "931237132907425";

declare global {
  interface Window {
    fbq?: any;
    _fbq?: any;
  }
}

/**
 * Injects the official Meta Pixel base code and fires a PageView.
 * Safe to call multiple times: initialization only happens once.
 */
export function initMetaPixel(): void {
  if (typeof window === "undefined" || typeof document === "undefined") return;

  if (!window.fbq) {
    const fbq: any = function (...args: unknown[]) {
      if (fbq.callMethod) {
        fbq.callMethod.apply(fbq, args);
      } else {
        fbq.queue.push(args);
      }
    };

    window.fbq = fbq;
    window._fbq = window._fbq || fbq;
    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = "2.0";
    fbq.queue = [];

    const script = document.createElement("script");
    script.async = true;
    script.src = "https://connect.facebook.net/en_US/fbevents.js";
    // Append to head (or body as a fallback) instead of relying on an
    // existing <script> tag being present in the document.
    const target = document.head || document.body || document.documentElement;
    if (target) {
      target.appendChild(script);
    }
  }

  window.fbq("init", PIXEL_ID);
  window.fbq("track", "PageView");
}

/** Fires a standard or custom Meta Pixel event. */
export function trackPixelEvent(event: string, data?: Record<string, unknown>): void {
  if (typeof window === "undefined" || !window.fbq) return;
  window.fbq("track", event, data);
}
